:host {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;

  .uic-thumbnail__control {
    display: none;
  }

  .uic-thumbnail__items {
    min-height: 64px;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: scroll;
    scroll-behavior: smooth;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  slot {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

:host(.uic-thumbnail--controls-visible) {
  .uic-thumbnail__control {
    display: block;
  }
}
